import './header.scss'
import React from "react";
import {ModelConsumer} from "../../helpers/model/model-consumer.js";
import {ModelPaths} from "../../models/paths.js";

const NavList = function (props) {
    return <div id={props.id} className={'zol-nav-container'}  style={{...props.style}}>
        <ModelConsumer model={ModelPaths}>
            {(resultSet)=>{
                return resultSet.data.map((item, key)=>{
                    const selected = (props.selected === key) ? {backgroundColor: '#b8cf41', color: '#fff'} : {}
                    return <a key={key} href={item.url}
                              className={'zol-nav-item'}
                              style={{...props.itemStyle, ...selected}}>
                        {item.title}
                    </a>
                })
            }}
        </ModelConsumer>
    </div>
}

export {NavList}